import { Stack } from '@mui/material';
import { memo } from 'react';
import { IssueGroupSkeleton } from './IssueGroupSkeleton';

export const IssuesListSkeleton = memo(() => {
  return (
    <Stack gap={2}>
      {Array(5)
        .fill('')
        .map((_, index) => (
          <IssueGroupSkeleton key={index} open={index === 0} />
        ))}
    </Stack>
  );
});
